import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=51f77f4c"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports